export enum RemindPasswordMethodTypeEnum {
    Email = 1,
    Phone = 2
}